export const ForgingBrainsVideo_1 = require('./forgingbrainsclip1.mp4');
export const ForgingBrainsVideo_2 = require('./forgingbrainsclip2.mp4');
